import EmailErrorList from './component'

export default EmailErrorList
